/**
 * Machinery Equipment Guidance - SIMPLIFIED DIRECT SYSTEM
 * Every requirement ID maps directly to guidance - NO MAPPINGS, NO COMPLEXITY
 * Based on Regulations Assistant verified guidance from MACHINERY_EQUIPMENT_GUIDANCE_PART1.md and PART2.md
 */

import { MACHINERY_SIMPLE_GUIDANCE, getMachinerySimpleGuidance } from './machinery.simple.js';

/**
 * Simple Direct Machinery Guidance - NO MAPPINGS
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getMachineryGuidance(itemId) {
  return getMachinerySimpleGuidance(itemId);
}

// Export the guidance object for compatibility
export { MACHINERY_SIMPLE_GUIDANCE as MACHINERY_GUIDANCE };